import immutable from 'immutable';

const ARES = '@@client/ARES';
const ARES_SUCCESS = '@@client/ARES_SUCCESS';
const ARES_FAIL = '@@client/ARES_FAIL';

const initialState = immutable.fromJS(
	{
		ares: {
			pending: false
		}
	}
);

export default function reducer(state = initialState, action = {}) {
	switch (action.type) {

		case ARES:
			return state.setIn(['ares', 'pending'], true);

		case ARES_SUCCESS:
		case ARES_FAIL:
			return state.setIn(['ares', 'pending'], false);

		default:
			return state;
	}
}

export function getAres(ic) {
	return {
		types: [ARES, ARES_SUCCESS, ARES_FAIL],
		promise: (client) => client.call('client.getAres', {ic}, {progress: true})
	};
}


// WEBPACK FOOTER //
// ./src/redux/modules/client.js